export default __webpack_public_path__ + "static/media/Ballroll_00201.d713ddeb.png";